<template>
  <div class=" ioRecord">
    <div class="">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>停车场:</label>
            <el-select v-model="search.parkingId" style="width:180px">
              <el-option
                v-for="item in shareParksData"
                :key="item.parkingId"
                :label="item.parkingName"
                :value="item.parkingId"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>订单状态:</label>
            <el-select v-model="search.status" style="width:180px">
              <el-option
                v-for="[key, value] in Object.entries(orderStatusType)"
                :key="key"
                :value="key"
                :label="value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>车牌号码:</label>
            <input
              v-model="search.plateNumber"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for>车位号:</label>
            <input
              v-model="search.uniqueId"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>

          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
          </div>
        </form>
      </div>
      <!--左侧列表展示进出场记录-->
      <div class="list-right">
        <el-table
          border
          :data="tableListData.rows"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="车场名称"
            prop="parkingName"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车牌号码"
            prop="plateNumber"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车位号"
            prop="uniqueId"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="预约下单时间"
            prop="createTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="预约入场时间"
            prop="bookIn"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="预约出场时间"
            prop="bookOut"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="实际入场时间"
            prop="actualIn"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="实际出场时间"
            prop="actualOut"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="支付金额"
            prop="amount"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="状态"
            prop="status"
          >
          <template v-slot="scope">
            {{ orderStatusType[scope.row.status] }}
          </template>
        </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {

  reservationRecord,
  shareParks,
} from "@/api/url";

import Page from "@/page/commons/parking/commons/page.vue";


export const ORDER_STATUS_TYPE = Object.freeze({
  1: "新建预约",
  2: "已取消",
  3: "已完成",
  4: "未进场",
  5: "已进场",
  6: "超时未进场已取消",
  7: "超时未支付已取消",
});

export default {
  data() {
    return {
      orderStatusType: { ...ORDER_STATUS_TYPE },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      search: {
        pageNumber: 1,
        pageSize: 10,
        parkingId: "",
        status: "",
        plateNumber: "",
        uniqueId: "",
      },
      tableListData: {
        rows: [],
      },
      shareParksData: [],

      formLabelWidth: "100px",
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },
    getShareParks() {
      this.$postRequest(shareParks(), {}).then((data) => {
        this.shareParksData = data?.data?.data?.rows ?? [];
      });
    },
    handleSearchParams(params) {
      return Object.entries(params).reduce((res, [key, value]) => {
        if (value) {
          res[key] = value;
        }
        return res;
      }, {});
    },
    tableList: function(curPage) {
      var _this = this;
      const params = this.handleSearchParams({ ...this.search });

      this.$get(reservationRecord(), {
        ...params,
      }).then((data) => {
        if (data.status != 200) return;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows;
      });
    },

    searchList: function() {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
   
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
  },

  mounted: function() {
    this.getShareParks();
    this.tableList(this.search.pageNumber);
  },
};
</script>

<style scoped>
.boxbgcolor {
  /*margin-top:20px;*/
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.demo-table-expand {
  font-size: 0;
}
.detail {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.detail ul {
  width: 50%;
}
.detail ul li {
  padding: 10px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.detail ul li span {
  display: inline-block;
  width: 50%;
}
.detail ul li span:first-child {
  text-align: right;
  color: #aaa;
  font-weight: bold;
  width: 100px;
}
.detail ul li span:last-child {
  text-align: left;
  padding: 0 0 0 20px;
}
.list-yes-tree {
  /* height:calc(100% - 100px); */
  overflow: auto;
}
</style>
<style>
.ioRecord .el-select {
  width: 100px;
}
</style>
